import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Button, Modal, Typography } from '@material-ui/core/'
import { TitleMediumBold } from '../../theme/typography'

const useStyles = makeStyles((theme) => ({
  modalWrap: {
    overflow: 'auto'
  },
  whiteBox: {
    position: 'absolute',
    top: '2vw',
    left: '2vw',
    borderRadius: '4px',
    width: '96vw',
    maxWidth: (props) => (props.isThin ? '510px' : '100%'),
    backgroundColor: theme.colors.white,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 0),
    outline: 'none',
    height: 'auto',
    overflowX: 'hidden',
    overflowY: 'auto',
    [theme.breakpoints.up('sm')]: {
      width: '80vw',
      transform: 'translate(-50%, -50%)',
      top: '50%',
      left: '50%'
    },
    [theme.breakpoints.up('lg')]: {
      width: '60vw'
    }
  },
  title: {
    padding: theme.spacing(0, 3, 2),
    borderBottom: `1px solid ${theme.colors.grey3}`,
    fontSize: '1.25rem !important'
  },
  body: {
    display: 'flex',
    padding: theme.spacing(2, 3),
    borderBottom: `1px solid ${theme.colors.grey3}`,
    alignItems: 'flex-start',
    '& h4': {
      marginTop: '1.33rem',
      letterSpacing: 0
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  imageClass: {
    maxWidth: '100%',
    margin: theme.spacing(3, 2, 3, 7),
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  button: {
    height: 36,
    fontSize: '14px !important',
    fontWeight: 'bold !important',
    letterSpacing: '1.5px !important',
    padding: '0 1rem !important',
    boxShadow: 'none !important',
    transition: 'all .3s ease-in-out !important',
    backgroundImage: `linear-gradient(100deg, ${theme.colors.blue5}, ${theme.colors.blue5})`,
    '&:hover': {
      color: theme.colors.white,
      backgroundImage: `linear-gradient(100deg, ${theme.colors.blue4}, ${theme.colors.blue5})`
    }
  },
  bottom: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: theme.spacing(2.5),
    marginBottom: 0
  }
}))

export default function ModalComponent(props) {
  const classes = useStyles(props)

  const [open, setOpen] = React.useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    window.history.replaceState(null, null, ' ')
    setOpen(false)
  }

  useEffect(() => {
    const funcRef = () => {
      if (window.location.hash.substr(1) === props.id) {
        handleOpen()
      }
    }
    window.addEventListener('load', funcRef, false)
    window.addEventListener('hashchange', funcRef, false)
    return () => {
      window.removeEventListener('load', funcRef, false)
      window.removeEventListener('hashchange', funcRef, false)
    }
  }, [])

  return (
    <Modal
      className={classes.modalWrap}
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className={classes.whiteBox}>
        <TitleMediumBold variant="h3" className={classes.title}>
          {props.title}
        </TitleMediumBold>
        <Box className={classes.body}>
          <Typography
            component="div"
            variant="body1"
            dangerouslySetInnerHTML={{
              __html: props.content
            }}
          />
          {props.image && (
            <img src={props.image} alt={props.imageAlt} className={classes.imageClass} />
          )}
        </Box>
        {props.closeText && (
          <Box className={classes.bottom}>
            <Button
              onClick={handleClose}
              variant="contained"
              color="secondary"
              size="small"
              className={classes.button}
            >
              {props.closeText}
            </Button>
          </Box>
        )}
      </div>
    </Modal>
  )
}
